import { FooterIcon } from 'src/utils/Icon'
import { ExplanationImg } from './style'

const MoveOutPageImage = () => {
  return (
    <a href="https://m-em.co.jp/saibugas/Omoushikomi/" target="_blank" rel="noreferrer">
      <ExplanationImg src={FooterIcon.MoveOut} alt="新生活は西部ガスの電気でお得に！" />
    </a>
  )
}

export default MoveOutPageImage
